import { Fragment, useEffect, useState } from "react";
import { ButtonGroup, TextField, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { blueGrey } from "@mui/material/colors";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

export interface CounterDelegate {
  didSetValueTo(value: number): void;
}

interface Props {
  minValue: number;
  startValue: number;
  delegate: CounterDelegate;
  disabled?: boolean;
}

const StyledInput = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: 'transparent',
      borderRadius: '8px',
      margin: '4px'
    },
    "&:hover fieldset": {
      borderColor: blueGrey[300]
    },
    "&.Mui-disabled fieldset": {
      borderColor: 'transparent'
    },
    "& input": {
      textAlign: "center",
      width: 60,
      color: blueGrey[700]
    }
  }
});

function Counter(props: Props) {
  const [count, setCount] = useState(props.startValue);

  useEffect(() => {
    setCount(props.startValue);
  }, [props.startValue]);

  const setAndNotifyCount = (value: number) => {
    if (props.disabled) {
      return;
    }
    setCount(value);
    props.delegate.didSetValueTo(value);
  }

  const handleChange = (event: any) => {
    const value = Math.max(Number(event.target.value), props.minValue);
    setAndNotifyCount(value)
  };
  return (
    <Fragment>
      <ButtonGroup sx={{
        border: '1px solid',
        borderColor: blueGrey[200],
        borderRadius: '20px',
      }}>
        <IconButton
          aria-label="remover"
          size="medium"
          sx={{
            backgroundColor: "grey.200",
            color: "primary.main",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
          onClick={() => setAndNotifyCount(count - 1)}
          disabled={props.disabled || count === props.minValue}
          title="Remover"
        >
          <RemoveIcon />
        </IconButton>

        <StyledInput
          size="small"
          onChange={handleChange}
          value={count}
          disabled={props.disabled}
        />

        <IconButton
          aria-label="adicionar"
          size="medium"
          sx={{
            backgroundColor: "grey.200",
            color: "primary.main",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
          onClick={() => setAndNotifyCount(count + 1)}
          disabled={props.disabled}
          title="Adicionar"
        >
          <AddIcon />
        </IconButton>
      </ButtonGroup>
    </Fragment>
  );
}

export default Counter
